import { jsx as _jsx } from "react/jsx-runtime";
const TideeLogo = ({ align = 'left', bold = false, children, className = '', reverse = false, size, }) => {
    const style = {
        color: reverse ? '#ffffff' : 'var(--color-primary-800)',
        fontFamily: bold
            ? '\'poppinssemibold\', helvetica, arial'
            : '\'poppinsmedium\', helvetica, arial',
        fontSize: `${size}px`,
        lineHeight: `${size}px`,
        textAlign: align,
        textDecoration: 'none',
    };
    return (_jsx("div", { className: className, style: style, children: children }));
};
export default TideeLogo;
//# sourceMappingURL=tidee-logo.js.map